import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { animate, state, style, transition, trigger } from '@angular/animations';

export interface HeaderLabelCellConfig {
  lottie?: AnimationOptions;
  leftTitle: string;
  leftTitleSemibold?: boolean;
  leftSubtitle?: string;
  leftContentFullWidth?: boolean;
  rightTitle?: string | number | null;
  rightTitleSemibold?: boolean;
  rightSubtitle?: string;
  rightSubtitleNoWrap?: boolean;
  rightIconName?: string;
  rightIconColor?: string;
  routeLink?: string;
  lottieLoading?: boolean;
  bgColor?: string;
  minHeight?: string;
}

@Component({
    selector: 'bw-header-label-cell-legacy',
    templateUrl: './header-label-cell.component.html',
    styleUrls: ['./header-label-cell.component.scss'],
    standalone: false
})
export class HeaderLabelCellComponentLegacy {
  @Input() labelCellConfig: HeaderLabelCellConfig;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  @Output() clickEvent?: EventEmitter<void> = new EventEmitter<void>();
  @Input() hasContent = false;

  lottieLoaderDots: AnimationOptions = {
    path: './assets/animation/loaderdots.json'
  };

  lottieStyles = {
    width: '24px',
    height: '24px',
  };

  onAnimationCreated(animation: any): void {

  }

  onContainerClick(): void {
    this.clickEvent?.emit();
  }
}
